import { NotifyHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

export const anewNotifyHttp = () => {
  try {
    return new NotifyHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint NotifyHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)    
    throw error
  }
}
